module.exports = __webpack_public_path__ + "static/media/document_information.5e6119a7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/go/documents/adhesion/document_information.pdf
// module id = 305
// module chunks = 40